import { UserOutlined } from '@ant-design/icons'
import { Avatar, Checkbox } from 'antd'
import Skeleton from 'react-loading-skeleton'

import B2becTranslation from '@/components/B2becTranslation'
import FormatPrice from '@/components/FormatPrice'
import { ReorderIcon } from '@/components/Icons'
import { checkListPriceIsZero } from '@/libs/utils/common'

const renderColumns = (
  addToCartHandler,
  handleCellClick,
  isLoading,
  onCheckHandler,
  comparingProductIds,
  hasAddProductToCartPermission,
  hasProductComparisonPermission,
) =>
  [
    {
      dataIndex: 'imageUrl',
      onCell: ({ materialNumber, materialId }) => ({
        onClick: () => handleCellClick(materialNumber || materialId),
      }),
      width: '10%',
      render: (text) =>
        isLoading
          ? <Skeleton />
          : text
          ? <Avatar shape="square" size={64} src={text} />
          : <Avatar icon={<UserOutlined />} shape="square" size={64} />,
    },
    {
      title: <B2becTranslation value="cart.table.itemNo" />,
      width: '15%',
      dataIndex: 'materialNumber',
      onCell: ({ materialNumber, materialId }) => ({
        onClick: () => handleCellClick(materialNumber || materialId),
      }),
      render: (text) => (isLoading ? <Skeleton /> : <span>{text}</span>),
    },
    {
      title: <B2becTranslation value="cart.table.itemName" />,
      dataIndex: 'name',
      onCell: ({ materialNumber, materialId }) => ({
        onClick: () => handleCellClick(materialNumber || materialId),
      }),
      render: (text) => (isLoading ? <Skeleton /> : <span>{text}</span>),
    },
    {
      title: <B2becTranslation value="productCard.listPrice" />,
      dataIndex: 'price',
      align: 'right',
      width: '10%',
      onCell: ({ materialNumber, materialId }) => ({
        onClick: () => handleCellClick(materialNumber || materialId),
      }),
      render: (text, record) =>
        isLoading
          ? <Skeleton />
          : checkListPriceIsZero(record.price)
          ? <B2becTranslation value="productCard.onRequest" />
          : (
            <FormatPrice
              currencyUnit={record?.currencyUnit || record?.currency}
              price={text}
            />
          ),
    },
    {
      title: <B2becTranslation value="productComparison.tableColumn.title" />,
      width: '20%',
      dataIndex: 'comparison',
      align: 'left',
      hidden: !hasProductComparisonPermission,
      render: (_, record) => {
        const isComparingProduct = (comparingProductIds ?? []).includes(
          record?.materialNumber || record?.materialId,
        )
        return isLoading ? <Skeleton /> : (
          <Checkbox
            checked={isComparingProduct}
            className="kaercher-checkbox"
            onChange={(e) => onCheckHandler(record, e)}
          >
            <B2becTranslation value="productComparison.button" />
          </Checkbox>
        )
      },
    },
    {
      align: 'right',
      width: '5%',
      render: (_, record) => {
        const isBProgramProduct = record?.requiresInstruction
        const shouldDisplayAddToCart = record?.displayAddToCart && hasAddProductToCartPermission

        const shouldHideAddToCartButton = !shouldDisplayAddToCart
          || isBProgramProduct
          || checkListPriceIsZero(record?.listPrice || record?.price)

        return isLoading ? <Skeleton /> : shouldHideAddToCartButton ? null : (
          <button
            className="button-as-link order-history__btn--reorder"
            type="button"
            onClick={() => addToCartHandler(record.materialNumber || record.materialId)}
          >
            <ReorderIcon />
          </button>
        )
      },
    },
  ].filter((col) => !col.hidden)

export default renderColumns
